var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row no-gutters" },
    [
      _c("span", { domProps: { innerHTML: _vm._s(_vm.defaultStyle) } }),
      _vm._v(" "),
      _c("modal", {
        ref: "defaultSettingsModal",
        on: { hidden: _vm.resetDraftTemplateDefaultSettings },
        scopedSlots: _vm._u([
          {
            key: "modal-body",
            fn: function() {
              return [
                _c("template-default-settings", {
                  staticClass: "w-50 mx-auto",
                  model: {
                    value: _vm.draftTemplateDefaultSettings,
                    callback: function($$v) {
                      _vm.draftTemplateDefaultSettings = $$v
                    },
                    expression: "draftTemplateDefaultSettings"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "modal-footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.applyDraftDefaultSettings }
                  },
                  [_vm._v("Toepassen")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [
        _c(
          "div",
          {
            ref: "settingsLeft",
            staticClass: "template-manager-settings template-manager-left"
          },
          [
            _vm.name != null && _vm.subject != null
              ? _c("TemplateSettings", {
                  attrs: {
                    name: _vm.name,
                    subject: _vm.subject,
                    sender: _vm.sender,
                    "sender-name": _vm.senderName,
                    "custom-css": _vm.customCss,
                    templates: _vm.templates,
                    parentId: _vm.parentId,
                    modified: _vm.modifiedFormatted,
                    canPickParent: _vm.canPickParent
                  },
                  on: {
                    "rename-template": function($event) {
                      return _vm.$emit("change-name", $event)
                    },
                    "rename-subject": function($event) {
                      return _vm.$emit("change-subject", $event)
                    },
                    "rename-sender": function($event) {
                      return _vm.$emit("change-sender", $event)
                    },
                    "rename-sender-name": function($event) {
                      return _vm.$emit("change-sender-name", $event)
                    },
                    "change-custom-css": function($event) {
                      return _vm.$emit("change-custom-css", $event)
                    },
                    "set-parent": function($event) {
                      return _vm.$emit("set-parent", $event)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-8" },
        [
          _c("div", { staticClass: "template-manager-template" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-11 mx-auto" }, [
                _c("h3", [_vm._v(_vm._s(_vm.name))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "mx-auto col-11 p-2 text-center template-header"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "template-header",
                    {
                      staticClass: "d-inline-block",
                      attrs: { size: _vm.templateDefaultSettings.headingSize }
                    },
                    [_vm._v(_vm._s(_vm.subject))]
                  ),
                  _vm._v(" "),
                  _vm.parentId === null
                    ? _c("i", {
                        staticClass:
                          "fas fa-lg fa-ellipsis-v float-right mdb-icon-btn edit",
                        attrs: { "aria-hidden": "true" },
                        on: { click: _vm.showDefaultSettingsModal }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-auto col-11 template-container" },
                [
                  _c(
                    "TemplateItem",
                    {
                      attrs: {
                        classes: "template p-3 border bg-light",
                        metadata: {},
                        isSelected: false,
                        parentId: _vm.parentId,
                        controlsStyle: "top: -45px;",
                        isParent: _vm.parentId != null,
                        locked: _vm.locked,
                        hideSort: true,
                        hideDelete: true
                      },
                      on: {
                        "unselect-all": function($event) {
                          _vm.selectedPage = null
                        },
                        "lock-item": function($event) {
                          return _vm.$emit("lock-template", $event)
                        }
                      }
                    },
                    [
                      _vm._l(_vm.sortedPages, function(page) {
                        return _c("templatePage", {
                          key: page._key,
                          attrs: {
                            id: page.Id,
                            parentId: page.ParentId,
                            currentTemplateId: _vm.id,
                            templateId: page.TemplateId,
                            name: page.Name,
                            metadata: page.Metadata,
                            blocks: page.Blocks,
                            isSelected: _vm.selectedPage === page,
                            locked: page.IsLocked,
                            lockStateChanged: page.LockStateChanged
                          },
                          on: {
                            "select-page": function($event) {
                              _vm.selectedPage = page
                            },
                            "delete-page": function($event) {
                              return _vm.deletePage($event)
                            },
                            "move-page": function($event) {
                              return _vm.movePage($event.old, $event.new)
                            },
                            "rename-page": function($event) {
                              page.Name = $event
                            },
                            "lock-page": function($event) {
                              return _vm.togglePageLock(page, $event)
                            },
                            "unselect-all": function($event) {
                              _vm.selectedPage = null
                            },
                            "change-width": function($event) {
                              page.Metadata.style.width = $event
                            },
                            "change-color": function($event) {
                              page.Metadata.style.color = $event
                            },
                            "change-crop": function($event) {
                              return _vm.setCrop(page, $event)
                            },
                            "change-image": function($event) {
                              page.Metadata.style.mediaId = $event
                            },
                            "change-margin": function($event) {
                              page.Metadata.style.margin = $event
                            },
                            "item-added": function($event) {
                              _vm.itemAdded = true
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "pagenumber",
                                fn: function() {
                                  return [
                                    _c("span", { staticClass: "pull-right" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.resource(
                                            "Template_PageNumber_Page_Label"
                                          )
                                        ) +
                                          " " +
                                          _vm._s(page.Metadata.index)
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      }),
                      _vm._v(" "),
                      !_vm.controlsLocked
                        ? _c("div", [
                            _c("i", {
                              staticClass:
                                "mdb-icon-btn new fa fa-plus-circle fa-3x page-btn",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.addPage()
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [
        _c("div", {
          ref: "settingsRight",
          staticClass: "template-manager-settings template-manager-right"
        })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "template-header-icon" }, [
      _c("i", { staticClass: "fas fa-mail-bulk fa-3x text-white" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }